import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

const FEATURE_KEY = 'appHomeScreenSections';

interface AppHomeScreenSectionsState {
  activeSections: string[];
}

const initialHomeScreenSectionsState: AppHomeScreenSectionsState = {
  activeSections: [
    'my_event_slider',
    'widgets',
    'upcoming_club_games',
    'game_reports',
    'upcoming_league_games',
  ],
};

const _appHomeScreenSectionsSlice = createSlice({
  name: FEATURE_KEY,
  initialState: initialHomeScreenSectionsState,
  reducers: {
    update: (state, action: PayloadAction<string[]>) => {
      state.activeSections = action.payload;
    },
  },
});

/*
 * Export reducer for store configuration.
 */
const reducer = _appHomeScreenSectionsSlice.reducer;
const actions = _appHomeScreenSectionsSlice.actions;

const getHomeScreenSectionsState = (
  rootState: any
): AppHomeScreenSectionsState => rootState[FEATURE_KEY];

const activeSectionsSelector = createSelector(
  getHomeScreenSectionsState,
  (state) => state.activeSections
);

export {
  actions,
  activeSectionsSelector,
  initialHomeScreenSectionsState,
  reducer,
};
